import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../../services/authentication.service';

// import { AutologoutService } from 'src/services/member/autologout.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    currentTwofaToken: any;
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && (currentUser.token || currentUser['Two-FA-Token']) && (currentUser.header)) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'JWT ' + currentUser.token
                }
            });

            if(request.url.includes('tenants/basic-info/')) {
                request = request.clone({
                    headers: new HttpHeaders({
                    })
                });
            }

            if(request.url.includes('generate-email-otp/') || request.url.includes('verify-email-otp/') || request.url.includes('generate-2fa-qr/') || request.url.includes('setup-2fa/') || request.url.includes('verify-totp/')){
                this.currentTwofaToken = localStorage.getItem('for_2fa_only')
                request = request.clone({
                    headers: new HttpHeaders({
                        'Two-FA-Token': this. currentTwofaToken
                    })
                });
            }
        }
        else {
            let setHeaders: any = {}
            request = request.clone({ setHeaders: setHeaders });
        }
        return next.handle(request);
    }
}